<div class="container-fluid" *ngIf="isLoaded" [@fadeInAnimation]>
  <div class="row">
    <div class="col-xl-1"></div>
    <div class="col-xl-10">
      <div class="row">
        <div class="col-lg-6 mb-3 pr-1andahalf-lg">
          <div class="card">
            <div class="card-header">
              <fa-icon [icon]="['fas', 'marker']" size="lg" class="me-2" [fixedWidth]="true"></fa-icon>{{ 'label.info-request' | translate}}
            </div>
            <div class="card-body">
              <p class="h5">{{ infoRequest.about }}</p>
              <ul class="list-unstyled">
                <li>
                  {{ 'label.sender' | translate }}
                  <ul class="list-unstyled ms-3">
                    <li><b>{{ infoRequest.requestFirm }}</b>, {{ infoRequest.date | localizeddate:'shortDate' }}</li>
                  </ul>
                </li>
                <li class="mt-2">
                  {{ 'label.status' | translate }}
                  <ul class="list-unstyled ms-3">
                    <li><b>{{ (infoRequest.answered ? "label.request-answered" : "label.request-waiting-response") | translate }}</b></li>
                  </ul>
                </li>
                <li class="mt-2">
                  {{ 'label.case' | translate }}
                  <ul class="list-unstyled ms-3">
                    <li>
                      <b>{{ infoRequest.case }} <ng-container *ngIf="infoRequest.caseOrgNr">({{infoRequest.caseOrgNr}})</ng-container></b>
                      <ng-container *ngIf="infoRequest.caseType === 'Konkurs' || infoRequest.caseType === 'rek'"> i {{ 'label.' + (infoRequest.caseType === 'Konkurs' ? 'konkurs' : 'rekonstruktion') | translate }}</ng-container>
                    </li>
                  </ul>
                </li>
                <li *ngIf="(infoRequest.caseType === 'rek' || infoRequest.caseType === 'Konkurs') && infoRequest.decisionDate" class="mt-2">
                  {{ 'label.' + (infoRequest.caseType === 'rek' ? 'beslutsdag' : 'konkursdag') | translate }}
                  <ul class="list-unstyled ms-3">
                    <li class="text-bold">{{ infoRequest.decisionDate | localizeddate:'shortDate' }}</li>
                  </ul>
                </li>
                <li *ngIf="infoRequest.trusteeName" class="mt-2">
                  {{ 'label.' + (infoRequest.caseType === 'Konkurs' ? 'konkursforvaltare' : 'foretagsrekonstruktor') | translate }}
                  <ul class="list-unstyled ms-3">
                    <li class="text-bold">{{ infoRequest.trusteeName }}</li>
                  </ul>
                </li>
                <li *ngIf="infoRequest.caseHandlerName" class="mt-2">
                  {{ 'label.kontaktperson' | translate }}
                  <ul class="list-unstyled ms-3">
                    <li class="text-bold">{{ infoRequest.caseHandlerName }}</li>
                    <li *ngIf="infoRequest.caseHandlerPhone">
                      <a [href]="'tel:' + infoRequest.caseHandlerPhone">{{ infoRequest.caseHandlerPhone }}<fa-icon [icon]="['fas', 'phone']" size="sm" class="ms-2"></fa-icon></a>
                    </li>
                    <li *ngIf="infoRequest.caseHandlerEmail">
                      <a [href]="'mailto:' + infoRequest.caseHandlerEmail">{{ infoRequest.caseHandlerEmail | lowercase }}<fa-icon [icon]="['fas', 'at']" size="sm" class="ms-2"></fa-icon></a>
                    </li>
                  </ul>
                </li>
              </ul>
            </div>
          </div>
        </div>
        <div class="col-lg-6 mb-3 pl-1andahalf-lg">
          <div class="card">
            <div class="card-header">
              <fa-icon [icon]="['far', 'comments']" size="lg" class="me-2" [fixedWidth]="true"></fa-icon>{{ 'label.conversation' | translate }}
            </div>
            <div class="card-body">
              <span class="d-flex justify-content-center text-muted" style="cursor: pointer" (click)="visaAllaMeddelanden = true" *ngIf="(infoRequest.messages.length > antalMeddelandenSomVisas) && !visaAllaMeddelanden">
                <fa-icon [icon]="['fas', 'caret-down']" size="lg" title="Visa tidigare meddelanden"></fa-icon>
              </span>
              <ng-container *ngFor="let meddelande of infoRequest.messages | orderBy: 'date'; let i = index">
                <div class="media pt-3" *ngIf="(i >= infoRequest.messages.length - antalMeddelandenSomVisas) || visaAllaMeddelanden">
                  <div class="avatar-circle me-3 ms-lg-3 ms-0 z-depth-1" [style.background-color]="meddelande.isFromGK ? '#d22' : '#22d'" [title]="meddelande.date">
                    <span class="initials">{{ meddelande.isFromGK ? infoRequest.firmInitials : infoRequest.userInitials }}</span>
                  </div>
                  <p class="media-body pb-3 mb-0 small lh-125 border-bottom border-gray">
                    <span class="d-block"><strong class="text-gray-dark">{{ meddelande.isFromGK ? infoRequest.requestFirm : infoRequest.usersName }}</strong>, {{ meddelande.date | localizeddate:'shortDate' }} {{ meddelande.date | localizeddate:'mediumTime' }}</span>
                    <span style="font-size: 1.2rem; white-space: pre-wrap">{{ meddelande.text }}</span>
                    <file-link-fromgk *ngIf="meddelande.fileId" [fileName]="meddelande.fileName" [fileId]="meddelande.fileId" [requestId]="infoRequest.id"></file-link-fromgk>
                  </p>
                </div>
              </ng-container>
              <p class="text-muted" *ngIf="!infoRequest.messages?.length">{{ label.no-messages }}</p>
              <form [formGroup]="userForm" (ngSubmit)="createMessage()">
                <div class="mb-3">
                  <textarea class="form-control mt-3" rows="3" placeholder="{{ 'label.type-here' | translate }}" id="message-text" name="message" formControlName="message"></textarea>
                </div>
                <div style="display: flex; justify-content: flex-end; margin-top: -10px;">
                  <label *ngIf="messageForm.dirty" class="smaller-label" [ngClass]="messageForm.invalid && message.length ? 'label-danger' : 'label-default'">{{ message.length | localizednumber }} / {{ messageMaxLength | localizednumber }} tecken</label>
                </div>
                <file-upload />
                <div class="container-fluid mt-3">
                  <div class="row">
                    <button type="submit" [disabled]="userForm.invalid && !(message.length === 0 && files.length !== 0)" class="btn-garanti btn-blue ms-auto"><fa-icon [icon]="['fas', 'envelope']" class="me-2"></fa-icon>{{ 'label.send-message' | translate }}</button>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
